import { render, staticRenderFns } from "./FocusBehaviorEditor.vue?vue&type=template&id=0ab92faa&"
import script from "./FocusBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./FocusBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports